var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHelp(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.2499 14.0362V15.5H11.7501V13.8524C11.7501 12.8525 12.3975 11.9862 13.3587 11.6986C13.8837 11.54 14.2499 11.0474 14.2499 10.5C14.2499 9.83364 13.665 9.25002 13 9.25002C12.31 9.25002 11.7501 9.8113 11.7501 10.5H9.24995C9.24995 8.4324 10.9324 6.74992 13 6.74992C15.0326 6.74992 16.7501 8.46739 16.7501 10.5C16.7501 12.0824 15.7313 13.5113 14.2499 14.0362ZM13 19.25C12.31 19.25 11.7501 18.69 11.7501 18.0001C11.7501 17.3101 12.31 16.7501 13 16.7501C13.69 16.7501 14.2499 17.3101 14.2499 18.0001C14.2499 18.69 13.69 19.25 13 19.25ZM13 0.499756C6.09615 0.499756 0.5 6.09484 0.5 13.0003C0.5 19.9041 6.09615 25.5003 13 25.5003C19.9038 25.5003 25.5 19.9041 25.5 13.0003C25.5 6.09537 19.9038 0.499756 13 0.499756Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelp);
export default __webpack_public_path__ + "static/media/help.7b6d0882.svg";
export { ForwardRef as ReactComponent };